

export class Client {
  public clientId: number;
  public entityId: number;
  public firstName: string;
  public firstLastName: string;
  public secondName: string;
  public secondLastName: string;
  public document: string;
  public celular: number;
  public whatsapp: number;
  public mail: string;
  public registeredBy: string;
  public identificationTypeId: number;
  constructor(
  ){  }
}